module.exports = __webpack_public_path__ + "static/media/svelte.d1c6fb0a.png";